import React, { useEffect } from 'react';
import cx from 'classnames';

import { animated, useTransition } from '@react-spring/web';

import styles from './toolbar.module.scss';
import Tooltip from '../tooltip';


interface ToolbarContainerProps {
  show: boolean;
  children: React.ReactNode;
  className?: string;
}

const ToolbarContainer = ({show, children, className}: ToolbarContainerProps) => {
  const [transitions, api] = useTransition(show, () => ({
    initial: { opacity: 1, bottom: 24 },
    from: { opacity: 0, bottom: -50 },
    enter: { opacity: 1, bottom: 24 },
    leave: { opacity: 0, bottom: -50 },
  }));

  useEffect(() => {
    api.start();
  }, [show]);

  return transitions((style, item) => (item) && (
    <animated.div style={style} className={cx(styles.container, className)}>
      {children}
    </animated.div>
  ));
}

interface ToolbarTextProps {
  children: React.ReactNode
}

const ToolbarText = ({children}: ToolbarTextProps) => {
  return (
    <div className={styles.text}>
      {children}
    </div>
  );
}

interface ToolbarIconButtonProps {
  icon: string;
  disabled?: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  tooltip?: string;
}

const ToolbarIconButton = ({icon, onClick, disabled, tooltip}: ToolbarIconButtonProps) => {

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  return (
    <Tooltip content={tooltip} placement='bottom'>
    <div className={cx(styles.item, styles.iconItem, {
      [styles.disabled]: disabled
    })} onClick={handleClick}>
      <i className={cx(styles.icon, icon)}></i>
    </div>
    </Tooltip>
  );
}

const ToolbarDivider:React.FC<object> = () => {
  return (
    <div className={styles.divider}></div>
  );
}

const Toolbar = {
  Container: ToolbarContainer,
  Text: ToolbarText,
  IconButton: ToolbarIconButton,
  Divider: ToolbarDivider
};

export default Toolbar;